import script from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=9447c49a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9447c49a"]])

export default __exports__